const SvgAutomation1 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="m72 120 34.42 34.27M117.73 154.43 152 120M152 120l40-40.18L111.82 0 32 80.18 72 120M106.42 234.27 72 200M152 120l40 39.82L152 200M106.47 85.4 72 120M152 120l-34.66-34.51M117.73 234.43 152 200M72 120l-40 40.18L72 200M117.73 314.43 152 280M152 280l40-40.18L152 200M72 200l-40 40.18L72 280M117.58 165.73 152 200M72 280l34.42 34.27M106.27 165.57 72 200M152 280l40 39.82L112.18 400 32 320.18 72 280M117.58 245.73 152 280M106.27 245.57 72 280M117.58 165.73c1.49-1.45 2.42-3.48 2.42-5.73s-.87-4.13-2.27-5.57M117.73 154.43c-1.45-1.49-3.48-2.43-5.73-2.43s-4.13.87-5.58 2.27M106.27 165.57c-1.4-1.44-2.27-3.41-2.27-5.57s.93-4.28 2.42-5.73M106.27 165.57c1.45 1.49 3.48 2.43 5.73 2.43s4.13-.87 5.58-2.27M106.42 234.27c1.44-1.4 3.41-2.27 5.58-2.27s4.28.93 5.73 2.43M117.58 245.73c1.49-1.45 2.42-3.48 2.42-5.73s-.87-4.13-2.27-5.57M117.58 245.73c-1.44 1.4-3.41 2.27-5.58 2.27s-4.28-.93-5.73-2.43M106.42 234.27c-1.49 1.45-2.42 3.48-2.42 5.73s.87 4.13 2.27 5.57"
    />
    <path
      d="M117.73 314.43c-1.45-1.49-3.48-2.43-5.73-2.43s-4.13.87-5.58 2.27"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M117.73 314.43A7.982 7.982 0 0 1 120 320c0 4.42-3.58 8-8 8a7.998 7.998 0 0 1-5.58-13.73M117.58 85.67c1.49-1.45 2.42-3.48 2.42-5.73s-.87-4.13-2.27-5.57M117.73 74.36c-1.45-1.49-3.48-2.43-5.73-2.43s-4.13.87-5.58 2.27M106.27 85.51c-1.4-1.44-2.27-3.41-2.27-5.57s.93-4.28 2.42-5.73M106.27 85.51c1.45 1.49 3.48 2.43 5.73 2.43s4.13-.87 5.58-2.27"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgAutomation1;
